import FadeInWrapper from './FadeInWrapper';

export default FadeInWrapper;
